
(function () {
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  class GmFacets extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;

      this.scrim = this.querySelector('.gm-facets__scrim');
      this.sheets = {
        filter: this.querySelector('#GmFilterSheet'),
        sort: this.querySelector('#GmSortSheet'),
      };
      this.openName = null;
      this.lastFocus = null;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));

      this._syncingAccordion = false;
      const filterSheet = this.sheets.filter;
      if (filterSheet) {
        filterSheet.querySelectorAll('.gm-facet').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (this._syncingAccordion || !details.open) return;
            this._syncingAccordion = true;
            filterSheet.querySelectorAll('.gm-facet[open]').forEach((other) => {
              if (other !== details) other.open = false;
            });
            this._syncingAccordion = false;
          });
        });
      }

      const mobileForm = this.querySelector('#FacetFiltersFormMobile');
      if (mobileForm) {
        mobileForm.addEventListener('input', () => {
          const collection = document.querySelector('#ProductGridContainer .collection');
          if (collection) collection.classList.add('loading');
        });
      }
    }

    onClick(event) {
      const opener = event.target.closest('[data-gm-facets-open]');
      if (opener) {
        event.preventDefault();
        this.open(opener.getAttribute('data-gm-facets-open'));
        return;
      }
      if (event.target === this.scrim || event.target.closest('[data-gm-facets-close]')) {
        event.preventDefault();
        this.close();
      }
    }

    onKeydown(event) {
      if (!this.openName) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key === 'Tab') this.trapFocus(event);
    }

    trapFocus(event) {
      const sheet = this.sheets[this.openName];
      if (!sheet) return;
      const items = Array.from(sheet.querySelectorAll(FOCUSABLE)).filter(
        (el) => el.offsetParent !== null
      );
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    open(name) {
      const sheet = this.sheets[name];
      if (!sheet || this.openName === name) return;

      if (this.openName && this.sheets[this.openName]) {
        this.sheets[this.openName].classList.remove('is-open');
        this.sheets[this.openName].hidden = true;
      } else {
        this.lastFocus = document.activeElement;
      }

      this.openName = name;
      this.scrim.hidden = false;
      sheet.hidden = false;
      document.documentElement.classList.add('gm-scroll-lock');

      void sheet.offsetWidth;
      this.classList.add('gm-facets--open');
      this.scrim.classList.add('is-open');
      sheet.classList.add('is-open');

      const target = sheet.querySelector('.gm-sheet__close');
      if (target) target.focus();
    }

    close() {
      if (!this.openName) return;
      const sheet = this.sheets[this.openName];
      this.openName = null;

      this.classList.remove('gm-facets--open');
      this.scrim.classList.remove('is-open');
      if (sheet) sheet.classList.remove('is-open');
      document.documentElement.classList.remove('gm-scroll-lock');

      const settle = () => {
        if (sheet) sheet.hidden = true;
        this.scrim.hidden = true;
      };
      if (sheet) {
        let done = false;
        const onEnd = () => {
          if (done) return;
          done = true;
          sheet.removeEventListener('transitionend', onEnd);
          settle();
        };
        sheet.addEventListener('transitionend', onEnd);
        setTimeout(onEnd, 400);
      } else {
        settle();
      }

      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }
  }

  if (!customElements.get('gm-facets')) customElements.define('gm-facets', GmFacets);
})();
